/* eslint-disable react/prop-types -- project uses JSX without PropTypes package */
import Modal from "../Modal";

export default function SizingChartConfirmModal({
  isOpen,
  onClose,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  isLoading = false,
  danger = false,
  showCancel = true,
}) {
  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose} className="max-w-[480px]">
      <div className="flex flex-col gap-4">
        {description ? (
          <p className="text-sm text-slate-600">{description}</p>
        ) : null}
        <div className="flex flex-wrap justify-end gap-2 pt-2">
          {showCancel ? (
            <button type="button" className="btn-outline" onClick={onClose}>
              {cancelLabel}
            </button>
          ) : null}
          <button
            type="button"
            disabled={isLoading}
            className={`btn-solid ${danger ? "btn-red" : ""} ${isLoading ? "loading" : ""}`}
            onClick={onConfirm}
          >
            {isLoading ? "Please wait…" : confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
